import { SelectList } from '@acies/core';
import { ComponentCO2 } from '@acies/domain';
import ComponentCO2ItemRenderer from './component-co2-item-renderer';

export class ComponentCO2List extends SelectList<ComponentCO2> {
	public constructor() {
		super();
		this.width = 'fill';
		this.height = 'fill';
		this.paddingHorizontal = 0;
		this.paddingVertical = 0;
		this.gapVertical = 0;
		this.hideScrollbars = true;
		this.ItemRenderer = ComponentCO2ItemRenderer;
	}
}

customElements.define('ac-component-co2-list', ComponentCO2List);
